import { Injectable } from '@angular/core';
import { createAction } from '@ngrx/store';

Injectable({
    providedIn: 'root'
});
export class TopNavigationBarActions {

    static openAdaptiveRule = createAction('[TopNavigation:AdaptiveRule] Open Adaption Rule');

    static openAdaptiveRuleCancel = createAction(
        '[TopNavigation:AdaptiveRule] Open Adaption Rule Cancelled');
}
